import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { internalEnvs } from '../../services/sfAuth/sfAuthConfig'
import { INTERNAL_PATHS } from './InternalConstants'
import GenerateFillablePDFForm from './screens/GenerateFillablePDFForm'

const ProgramManagerApplicationList = EgretLoadable({
  loader: async () => await import('./ProjectManagerApplicationList')
})

const BudgetEmbedded = EgretLoadable({
  loader: async () => await import('./BudgetEmbedded')
})

const ExportSurveys = EgretLoadable({
  loader: async () => await import('./ExportSurveys')
})

const ExportImportObjects = EgretLoadable({
  loader: async () => await import('./ExportImportObjects')
})

const TranslationsEditor = EgretLoadable({
  loader: async () => await import('./TranslationsEditor')
})

const FormConfigurablePrintView = EgretLoadable({
  loader: async () => await import('./FormConfigurablePrintView')
})

const ConfigurePortalConfigurations = EgretLoadable({
  loader: async () => await import('./ConfigurePortalConfigurations')
})

const ConfigureFundingStreams = EgretLoadable({
  loader: async () => await import('./funding-streams/ConfigureFundingStreams')
})

const TechnicalAdvisoryRanking = EgretLoadable({
  loader: async () => await import('./TechnicalAdvisoryRanking')
})

const Contract = EgretLoadable({
  loader: async () => await import('./Contract')
})

const ConfigureUserPermissions = EgretLoadable({
  loader: async () => await import('./ConfigureUserPermissions')
})

const AdminMultiuserPanel = EgretLoadable({
  loader: async () => await import('../forms/multiuser/admin/AdminMultiuserPanel')
})

const PageTranslations = EgretLoadable({
  loader: async () => await import('./PageTranslations')
})

const FAQTab = EgretLoadable({
  loader: async () => await import('../grants/FAQTab')
})

const FAQEditor = EgretLoadable({
  loader: async () => await import('../grants/FAQEditor')
})

const internalRoutes: RouteConfig[] = [
  {
    path: `${INTERNAL_PATHS.PROJECT_SCHEDULE}/:id`,
    component: EgretLoadable({
      loader: async () => await import('./GranteeReportEditor')
    }),
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_PM_SCHEDULE_EDITOR_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: INTERNAL_PATHS.TRANSLATIONS_EDITOR,
    component: TranslationsEditor,
    auth: authRoles.translator,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_TRANSLATIONS_EDITOR_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.PROGRAM_MANAGER_APPLICATION_LIST,
    component: ProgramManagerApplicationList,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_APPLICATION_LIST</Trans>,
    showCollapseBtn: true
  },
  {
    path: `${INTERNAL_PATHS.CONTRACT}/:id`,
    component: Contract,
    env: internalEnvs,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_CONTRACT_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.TECHNICAL_ADVISORY_RANKING,
    component: TechnicalAdvisoryRanking,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_TECHNICAL_ADVISORY_RANKING_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: `${INTERNAL_PATHS.BUDGET_WIDGET}/:id`,
    component: BudgetEmbedded,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_BUDGET_VIEW_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.EXPORT_SURVEYS,
    component: ExportSurveys,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_EXPORT_SURVEYS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.CREATE_FORM_PREVIEW_URL,
    component: FormConfigurablePrintView,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_CONFIGURABLE_FORM_URLS</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.FUNDING_STREAMS_EDITOR,
    component: ConfigureFundingStreams,
    auth: authRoles.admin,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_CONFIGURE_FUNDING_STREAMS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.PORTAL_CONFIGURATIONS,
    component: ConfigurePortalConfigurations,
    auth: authRoles.admin,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_PORTAL_CONFIGURATIONS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.CONFIGURE_USER_PERMISSIONS,
    component: ConfigureUserPermissions,
    auth: authRoles.admin,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_CONFIGURE_USER_PERMISSIONS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.PAGE_TRANSLATIONS,
    component: PageTranslations,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.EXPORT_IMPORT_OBJECTS,
    component: ExportImportObjects,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.ACTIVE_SESSIONS,
    component: AdminMultiuserPanel,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: INTERNAL_PATHS.GENERATE_PDF_FOR_APPLICATION,
    component: GenerateFillablePDFForm,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: '/internal/faq-editor',
    component: FAQEditor,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: '/internal/faq-preview',
    component: FAQTab,
    showCollapseBtn: true,
    auth: authRoles.admin
  }
]

export default internalRoutes
